export enum FRAUD_PERMISSIONS {
  INTEGRATION_DAILYFRAUD = 'INTEGRATION_DAILYFRAUD'
}
